/**
 * § F197 (2026-09-26) — THE HEAD-TO-HEAD GAMES, ON THE CLIENT.
 *
 * Jake: *"When I click head to head, break down each game with the number that
 * is waiting for my turn. Right now it's only Wordle, but code it as if there
 * are many games in head to head."*
 *
 * The category menu, the your-turn prompt and the per-game counts all read this
 * one list; adding a game is one entry here (plus its board and routes). The
 * `id` is the server registry's (`src/turn-based/registry.ts`) and is what
 * every match summary carries as `game_id`.
 */
import { H2H_HOME } from "./paths";
import type { WireMatchSummary } from "./types";

export interface H2HGame {
  /** Matches `WireMatchSummary.game_id` and the server registry. */
  id: string;
  name: string;
  blurb: string;
  /** The door's colour. */
  tone: string;
}

export const H2H_GAMES: readonly H2HGame[] = [
  {
    id: "wordle",
    name: "Wordle",
    blurb: "Think of a five-letter word and send it to somebody to figure out.",
    tone: "bg-brand-quaternary",
  },
  {
    // § F198 — Jake: *"Add doodle duel to head to head. Same basic play, but
    // follow the format of Wordle."*
    id: "doodle",
    name: "Doodle",
    blurb: "Draw a word and send it to somebody to guess.",
    tone: "bg-brand-accent-orange",
  },
];

/** § F198 — what the drawer's pick is worth; a correct guesser gets half. */
export const DOODLE_POINTS = { easy: 2, medium: 4, difficult: 6 } as const;

/** Where a game's list of matches lives. */
export const h2hGamePath = (gameId: string) => `${H2H_HOME}/${gameId}`;

/** The display name for a match's game; the id itself if it is unknown. */
export function h2hGameName(gameId: string): string {
  return H2H_GAMES.find((g) => g.id === gameId)?.name ?? gameId;
}

/** How many waiting matches each game has. Pure; exported for tests. */
export function turnsByGame(turns: readonly WireMatchSummary[]): Map<string, number> {
  const out = new Map<string, number>();
  for (const t of turns) out.set(t.game_id, (out.get(t.game_id) ?? 0) + 1);
  return out;
}
